"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const ColonyBenefit_1 = require("@/common/colonies/ColonyBenefit");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'BuildBenefit',
    props: {
        metadata: {
            type: Object,
            required: true,
        },
        idx: {
            type: Number,
            required: true,
        },
    },
    computed: {
        ColonyBenefit() {
            return ColonyBenefit_1.ColonyBenefit;
        },
        buildQuantityText() {
            return this.metadata.build.quantity[this.idx] > 1 ? String(this.metadata.build.quantity[this.idx]) : '';
        },
        resource() {
            return (this.metadata.build.resource ?? this.metadata.cardResource)?.toLowerCase();
        },
    },
});
